import { useSelector } from 'react-redux';
import { useCharacter } from '../../../../data/hooks';

export function useActiveInnkeeper() {
  const { activeInnkeeperId } = useSelector(state => state.inn);
  return useCharacter(activeInnkeeperId);
}
